import _ from 'lodash'

export default function getCartPrices(cart) {
  const { priceDetails } = cart
  return {
    currencyCode: _.get(cart, 'overrideCurrencyCode') || _.get(cart, 'currencyCode'),
    deliveryFee: _.get(priceDetails, 'deliveryFee')
      || _.get(priceDetails, 'cartDeliveryFee')
      || _.get(cart, 'shippingCharge'),
    serviceCharge: _.get(priceDetails, 'serviceCharge')
      || _.get(priceDetails, 'cartServiceCharge')
      || _.get(cart, 'serviceCharge'),
    vouchers: _.get(priceDetails, 'voucherAmount'),
    // discounts could be an array of discounts or a string value
    discountGroup: _.get(priceDetails, 'discountGroup')
      || _.get(priceDetails, 'cartDiscountGroup'),
    totalDiscount: _.get(priceDetails, 'totalDiscount')
      || _.get(cart, 'cartDiscount')
      || _.get(cart, 'discountedPrice'),
    subtotal: _.get(priceDetails, 'subtotalPrice')
      || _.get(priceDetails, 'cartSubtotalPrice')
      || _.get(cart, 'subtotalPrice'),
    // TODO: add tax
    // tax: 0,
    totalLoyaltyPoints: _.get(cart, 'loyaltyPointConsumed')
      || _.get(priceDetails, 'totalLoyaltyPoints'),
    total: _.get(priceDetails, 'totalPrice')
      || _.get(priceDetails, 'cartTotalPrice')
      || _.get(cart, 'totalPrice'),
  }
}
